import { Routes } from '@angular/router'

import { AuthGuard } from './core/guards/auth.guard'

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./core/auth/pages/auth-page/auth.component').then((m) => m.AuthComponent),
  },
  {
    path: 'authorization',
    loadComponent: () =>
      import('./layout/main-layout/pages/main-layout-page/main-layout-page.component').then(
        (m) => m.MainLayoutComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './features/carregamentos/pages/carregamento-programado-page/carregamento-programado-page.component'
          ).then((m) => m.CarregamentoProgramadoPageComponent),
      },
      // {
      //   path: '',
      //   loadComponent: () =>
      //     import('./features/inicial/pages/inicial-page/inicial-page.component').then(
      //       (m) => m.InicialPageComponent,
      //     ),
      // },
      // Carregamentos
      {
        path: 'carregamentos',
        loadComponent: () =>
          import(
            './features/carregamentos/pages/carregamento-programado-page/carregamento-programado-page.component'
          ).then((m) => m.CarregamentoProgramadoPageComponent),
      },
      {
        path: 'evento',
        loadComponent: () =>
          import(
            './features/carregamentos-eventos/pages/carregamento-evento-page/carregamento-evento-page.component'
          ).then((m) => m.CarregamentoEventoPageComponent),
      },
      {
        path: 'postagem',
        loadComponent: () =>
          import(
            './features/carregamentos/pages/carregamento-postagem-page/carregamento-postagem-page.component'
          ).then((m) => m.CarregamentoPostagemPageComponent),
      },
      {
        path: 'monitoramento',
        loadComponent: () =>
          import(
            './features/carregamentos/pages/carregamento-ativo-page/carregamento-ativo-page.component'
          ).then((m) => m.CarregamentoAtivoPageComponent),
      },
      {
        path: 'busca-carregamentos',
        loadComponent: () =>
          import(
            './features/carregamentos/pages/carregamento-finalizado-page/carregamento-finalizado-page.component'
          ).then((m) => m.CarregamentoFinalizadoPageComponent),
      },
      {
        path: 'acompanhamento',
        loadComponent: () =>
          import(
            './features/carregamentos/pages/carregamento-monitor-page/carregamento-monitor-page.component'
          ).then((m) => m.CarregamentoMonitorPageComponent),
      },
      {
        path: 'acompanhamento/:id',
        loadComponent: () =>
          import(
            './features/carregamentos/pages/carregamento-monitor-page/carregamento-monitor-page.component'
          ).then((m) => m.CarregamentoMonitorPageComponent),
      },
      // Cadastros
      {
        path: 'cliente',
        loadComponent: () =>
          import('./features/clientes/pages/cliente-page/cliente-page.component').then(
            (m) => m.ClientePageComponent,
          ),
      },
      {
        path: 'veiculo',
        loadComponent: () =>
          import('./features/veiculos/pages/veiculo-page/veiculo-page.component').then(
            (m) => m.VeiculoPageComponent,
          ),
      },
      {
        path: 'condutor',
        loadComponent: () =>
          import('./features/condutores/pages/condutor-page/condutor-page.component').then(
            (m) => m.CondutorPageComponent,
          ),
      },
      {
        path: 'armador',
        loadComponent: () =>
          import('./features/armadores/pages/armador-page/armador-page.component').then(
            (m) => m.ArmadorPageComponent,
          ),
      },
      {
        path: 'organizacao',
        loadComponent: () =>
          import('./features/organizacoes/pages/organizacao-page/organizacao-page.component').then(
            (m) => m.OrganizacaoPageComponent,
          ),
      },
      {
        path: 'rastreador',
        loadComponent: () =>
          import('./features/rastreadores/pages/rastreador-page/rastreador-page.component').then(
            (m) => m.RastreadorPageComponent,
          ),
      },
      {
        path: 'isca',
        loadComponent: () =>
          import('./features/iscas/pages/isca-page/isca-page.component').then(
            (m) => m.IscaPageComponent,
          ),
      },
      {
        path: 'usuario',
        loadComponent: () =>
          import('./features/aplicacao/components/usuario-form/usuario.component').then(
            (m) => m.UsuarioComponent,
          ),
      },
      // Gestão
      {
        path: 'indicador-painel',
        loadComponent: () =>
          import(
            './features/indicadores/pages/indicador-painel-page/indicador-painel-page.component'
          ).then((m) => m.IndicadorPainelPageComponent),
      },
      {
        path: 'indicador-condutor',
        loadComponent: () =>
          import(
            './features/indicadores/pages/indicador-condutor-page/indicador-condutor-page.component'
          ).then((m) => m.IndicadorCondutorPageComponent),
      },
      {
        path: 'indicador-condutor-mensal',
        loadComponent: () =>
          import(
            './features/indicadores/components/condutor-heatmap-mensal/condutor-heatmap-mensal.component'
          ).then((m) => m.CondutorHeatmapMensalComponent),
      },
      {
        path: 'indicador-cliente',
        loadComponent: () =>
          import(
            './features/indicadores/pages/indicador-cliente-page/indicador-cliente-page.component'
          ).then((m) => m.IndicadorClientePageComponent),
      },
      {
        path: 'indicador-carregamento',
        loadComponent: () =>
          import(
            './features/indicadores/pages/indicador-carregamento-page/indicador-carregamento-page.component'
          ).then((m) => m.IndicadorCarregamentoPageComponent),
      },
      {
        path: 'notificacoes',
        loadComponent: () =>
          import('./features/aplicacao/pages/notificacao-page/notificacao-page.component').then(
            (m) => m.NotificacaoPageComponent,
          ),
      },
      {
        path: 'ajuda',
        loadComponent: () =>
          import('./features/aplicacao/pages/ajuda-page/ajuda-page.component').then(
            (m) => m.AjudaPageComponent,
          ),
      },
      // Perfil e Configurações
      {
        path: 'perfil',
        loadComponent: () =>
          import('./features/aplicacao/pages/perfil-page/perfil.component').then(
            (m) => m.PerfilComponent,
          ),
      },
      {
        path: 'auth-user',
        loadComponent: () =>
          import('./core/auth/pages/auth-user-page/auth-user-page').then((m) => m.AuthUserPage),
      },
      {
        path: 'configuracoes',
        loadComponent: () =>
          import('./features/aplicacao/pages/configuracao-page/configuracao-page.component').then(
            (m) => m.ConfiguracaoPageComponent,
          ),
      },
    ],
  },
]
